import axios from 'axios'
import config from './ambiente'
import {USER_CONFIG} from '../config/UserConfig'
import storageService from '../services/storageService'
import {normalizarResponse, resultadoRequisicao} from './Api.config.service'
const baseUrl = config.apiUrlBase

axios.interceptors.request.use(async (config) => {
    if (
      !config.url.endsWith('login') ||
      !config.url.endsWith('refresh') ||
      !config.url.endsWith('signup')
    ) {
      //const userTokenExpiration = new Date(await AsyncStorage.getItem('userTokenExpiration'));
      const token = storageService.getItem(USER_CONFIG.token);
      //const tokenValido = 
      if(token){
        config.headers.Authorization = `Bearer ${token}`;
      }
    //   const today = new Date();
    //   if (today > userTokenExpiration) {
    //     // refresh the token here
    //     const userRefreshToken = await AsyncStorage.getItem('userRefreshToken');
    //   } else {
    //     const userToken = await AsyncStorage.getItem('userToken');
    //     config.headers.Authorization = `Bearer ${userToken}`;
    //   }
    }
  
    return config;
  }, (error) => {
    // I cand handle a request with errors here
    return Promise.reject(error);
  });

const headerConfig = {
    'Content-Type': 'application/x-www-form-urlencoded',
    //colocar o token 
  }
 
const  Api = {
    async post (url, data){     
        try{
          const result = await axios.post(`${baseUrl}${url}`,data, headerConfig);          
          return normalizarResponse(result);
        }catch(err){          
          return normalizarResponse(err);
        }
    },
    async put (url, data){
     
      try{
        const result = await axios.put(`${baseUrl}${url}`,data, headerConfig);          
        return normalizarResponse(result);
      }catch(err){          
        return normalizarResponse(err);
      }
  },
    async get(url){
      return await axios.get(`${baseUrl}${url}`, headerConfig);
    },
    
}

export default Api


// WEBPACK FOOTER //
// ./src/services/BaseService.js